"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const input_styles_1 = require("@/components/common/input/input.styles");
const radio_styles_1 = require("@/components/common/radio/radio.styles");
const radio_utils_1 = require("@/components/common/radio/radio.utils");
const toggle_controller_1 = require("@/controllers/toggle-controller");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
require("@/components/common/text/semantics/paragraph");
let Radio = class Radio extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.name = '';
        this.value = '';
        this.size = 'medium';
        this.checked = false;
        this.disabled = false;
        // shadow 안에서만 쓰는 label 연결용 id라 호스트의 id와 섞지 않는다.
        this.inputId = (0, utils_1.uniqueId)('radio');
        this.toggle = new toggle_controller_1.ToggleController(this, 'checked');
    }
    render() {
        return (0, lit_1.html) `
      <div>
        ${(0, radio_utils_1.renderRadioInput)(this, this.inputId, this.toggle, (0, lit_1.html) `
            <mm-paragraph><slot></slot></mm-paragraph>
          `)}
      </div>
    `;
    }
};
Radio.styles = [shared_styles_1.resetStyles, input_styles_1.visuallyHiddenInputStyles, radio_styles_1.radioStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Radio.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Radio.prototype, "value", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Radio.prototype, "size", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], Radio.prototype, "checked", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], Radio.prototype, "disabled", void 0);
Radio = __decorate([
    (0, decorators_js_1.customElement)('mm-radio')
], Radio);
exports.Radio = Radio;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmFkaW8uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJyYWRpby50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBc0M7QUFDdEMscURBQTJEO0FBRTNELHlFQUFrRjtBQUNsRix5RUFBb0U7QUFDcEUsdUVBQXdFO0FBQ3hFLHVFQUFrRTtBQUNsRSwrREFBNkU7QUFDN0UsbUNBQWtDO0FBQ2xDLHdEQUFxRDtBQUs5QyxJQUFNLEtBQUssR0FBWCxNQUFNLEtBQU0sU0FBUSxnQkFBVTtJQUE5Qjs7UUFFdUIsU0FBSSxHQUFHLEVBQUUsQ0FBQTtRQUNULFVBQUssR0FBRyxFQUFFLENBQUE7UUFDSyxTQUFJLEdBQWMsUUFBUSxDQUFBO1FBQ3hDLFlBQU8sR0FBRyxLQUFLLENBQUE7UUFDZixhQUFRLEdBQUcsS0FBSyxDQUFBO1FBQzdDLGdEQUFnRDtRQUN4QyxZQUFPLEdBQUcsSUFBQSxnQkFBUSxFQUFDLE9BQU8sQ0FBQyxDQUFBO1FBQzNCLFdBQU0sR0FBZ0MsSUFBSSxvQ0FBZ0IsQ0FBQyxJQUFJLEVBQUUsU0FBUyxDQUFDLENBQUE7SUFnQnJGLENBQUM7SUFkQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7VUFFTCxJQUFBLDhCQUFnQixFQUNoQixJQUFJLEVBQ0osSUFBSSxDQUFDLE9BQU8sRUFDWixJQUFJLENBQUMsTUFBTSxFQUNYLElBQUEsVUFBSSxFQUFBOztXQUVILENBQ0Y7O0tBRUosQ0FBQTtJQUNILENBQUM7O0FBdkJNLFlBQU0sR0FBRyxDQUFDLDJCQUFXLEVBQUUsd0NBQXlCLEVBQUUsMEJBQVcsQ0FBQyxDQUFBO0FBQ3pDO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzttQ0FBVTtBQUNUO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQztvQ0FBVztBQUNLO0lBQTFDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDO21DQUEyQjtBQUN4QztJQUE1QixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsT0FBTyxFQUFFLENBQUM7c0NBQWdCO0FBQ2Y7SUFBNUIsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxDQUFDO3VDQUFpQjtBQU5sQyxLQUFLO0lBRGpCLElBQUEsNkJBQWEsRUFBQyxVQUFVLENBQUM7R0FDYixLQUFLLENBeUJqQjtBQXpCWSxzQkFBSyJ9